import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight, Droplet, SprayCan, ShieldAlert, Info, CheckCircle, Edit3, RefreshCw, XCircle, AlertTriangle, Home, Utensils, Bath, Wind, Sparkles, Loader2, Car, CloudFog, Shirt, Baby, PawPrint } from 'lucide-react';
// import ReactMarkdown from 'react-markdown'; // ReactMarkdown の使用を停止

// 定数
const NIO1SE_FACTOR = 0.5;

// 製品ロゴ SVG コンポーネント
const ProductLogo = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 660 312" className={className}><g id="_ロゴのみ_黒" data-name="ロゴのみ_黒"><g><g><path fill="#FFF" d="M119.85,183.54v-86.65l130.74,62.84v-62.84h14.71v86.2l-130.74-62.83v63.28h-14.7Z"/><path fill="#FFF" d="M289.06,96.9h14.69v12.78h-14.69v-12.78ZM289.06,119.97h14.69v63.57h-14.69v-63.57Z"/><path fill="#FFF" d="M435.97,151.76c0,17.48-14.31,31.78-31.78,31.78h-51.53c-17.48,0-31.78-14.3-31.78-31.78s14.3-31.78,31.78-31.78h51.53c17.47,0,31.78,14.3,31.78,31.78ZM421.27,151.76c0-9.37-7.72-17.09-17.09-17.09h-51.53c-9.37,0-17.09,7.72-17.09,17.09s7.72,17.09,17.09,17.09h51.53c9.37,0,17.09-7.72,17.09-17.09Z"/><path fill="#FFF" d="M445.39,183.54v-14.69h16.11v14.69h-16.11Z"/><path fill="#FFF" d="M525.46,111.6h-33.9l5.41-14.69h43.19v86.64h-14.69v-71.94Z"/></g><g><path fill="#FFF" d="M288.5,201.22c-1.77,0-3.24,1.46-3.24,3.24s1.47,3.24,3.24,3.24h28.84c4.23,0,7.7,3.47,7.7,7.7s-3.49,7.71-7.7,7.71h-36.54l3.74-4.47h32.8c1.77,0,3.23-1.47,3.23-3.24s-1.46-3.24-3.23-3.24h-28.84c-4.22,0-7.71-3.45-7.71-7.71s3.47-7.71,7.71-7.71h36.54l-3.74,4.47h-32.8Z"/><path fill="#FFF" d="M337.17,207.69h33.16l-3.74,4.47h-29.42v6.48h37.39l-3.74,4.47h-38.12v-26.36h41.86l-3.74,4.47h-33.65v6.47Z"/></g><rect fill="#FFF" x="404.01" y="211.17" width="128.43" height="2.69"/><rect fill="#FFF" x="124.71" y="211.17" width="128.43" height="2.69"/></g></g></svg>
);
const MakerLogo = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 170" className={className}><g id="_白ロゴ_A_AdamasOcta" data-name="白ロゴ_A＋AdamasOcta"><g><g><g><path fill="#fff" d="M177.49,110.48l22.76-52.78h14.92l.26,52.78h-12.53l.42-10.28h-9.71l-3.66,10.28h-12.46ZM205.68,67.27h-.14l-8.61,23.65h7.18l1.58-23.65Z"/><path fill="#fff" d="M238,110.48l.97-4.58h-.14c-2.85,3.8-6.66,5.84-9.97,5.84-8.1-.28-8.09-7.95-6.67-14.64l2.9-13.65c1.32-6.19,5.05-13.51,12.44-13.51,2.96,0,5.57,1.27,7.16,4.71h.14l3.6-16.96h11.19l-11.22,52.78h-10.42ZM233.56,96.27c-.49,2.32-1.35,6.33,1.89,6.33,3.03,0,4.09-3.03,4.9-6.83l1.97-9.29c.72-3.38,1.09-7.46-1.67-7.39-3.59,0-4.39,4.43-4.93,6.97l-2.17,10.2Z"/><path fill="#fff" d="M276.37,106.96c-3.47,3.1-6.23,4.79-10.66,4.79-6.33,0-9.36-4.29-8.03-10.56,1.9-8.94,7.35-11.75,12.62-13.37,5.2-1.62,10.16-2.11,11.06-6.33.46-2.18-.4-4.08-2.65-4.08-4.08,0-4.68,2.82-5.59,6.12h-11.19c.83-4.93,3.03-8.3,6.24-10.49,3.21-2.18,7.27-3.1,11.78-3.1,11.05,0,14.34,3.38,12.5,12.03l-5.13,24.14c-.32,1.48-.21,2.95-.01,4.36h-10.91l-.03-3.52ZM279.27,91.34c-2.51,1.2-4.61,1.83-6.24,2.89-1.62.98-3.11,2.39-3.68,5.07-.52,2.46.58,4.22,3.26,4.22,3.31,0,4.74-3.45,5.35-5.98l1.32-6.19Z"/><path fill="#fff" d="M313.04,71.07l-.97,4.57h.14c2.59-3.59,6.52-5.49,9.59-5.7,3.64-.21,6.63,1.9,7.2,5.21h.14c2.79-3.52,6.1-5.21,9.27-5.21,5.28,0,9.38,2.88,8.24,8.23l-6.87,32.3h-11.19l5.98-28.15c.25-1.83-.13-3.38-2.27-3.24-1.99.07-3.28,1.2-3.71,3.24l-5.98,28.15h-11.19l5.98-28.15c0-1.69-.09-3.24-1.99-3.24-2.25,0-3.41,1.13-4,3.24l-5.98,28.15h-11.19l8.38-39.41h10.42Z"/><path fill="#fff" d="M367.58,106.96c-3.48,3.1-6.23,4.79-10.66,4.79-6.33,0-9.36-4.29-8.03-10.56,1.9-8.94,7.35-11.75,12.62-13.37,5.2-1.62,10.16-2.11,11.06-6.33.46-2.18-.4-4.08-2.65-4.08-4.08,0-4.68,2.82-5.59,6.12h-11.19c.83-4.93,3.03-8.3,6.24-10.49,3.21-2.18,7.27-3.1,11.78-3.1,11.05,0,14.34,3.38,12.5,12.03l-5.13,24.14c-.32,1.48-.21,2.95-.01,4.36h-10.91l-.02-3.52ZM370.48,91.34c-2.51,1.2-4.61,1.83-6.24,2.89-1.62.98-3.11,2.39-3.68,5.07-.52,2.46.58,4.22,3.25,4.22,3.31,0,4.74-3.45,5.35-5.98l1.32-6.19Z"/><path fill="#fff" d="M408.51,82.75c.14-1.34.43-2.67.16-3.73-.21-.99-.91-1.69-2.74-1.69-2.18,0-3.94.99-4.43,3.31-.45,2.11,1.09,3.17,2.6,4.01,6.54,3.31,13.95,5.21,11.96,14.57-1.87,8.8-9.35,12.53-17.58,12.53-8.87,0-14.25-3.8-11.81-13.3h10.7c-.35,1.34-.53,2.81-.15,4.01.32,1.13,1.21,1.9,2.9,1.9,2.39,0,4.27-1.2,4.8-3.73.25-1.2-.07-2.32-.83-3.03-4-2.39-9.9-4.08-12.57-8.09-1.44-2.18-1.86-4.51-1.25-7.39,1.81-8.51,9.35-12.18,17.16-12.18s13.84,4.08,11.57,12.81h-10.49Z"/></g><g><polygon fill="#fff" points="104.93 40.16 54.4 127.95 77.25 127.95 105.84 69.49 120.48 100.02 152.74 108.88 119.9 40.16 104.93 40.16"/><polygon fill="#fff" points="152.74 108.88 65.62 84.94 62.32 91.79 134.39 129.83 134.4 129.84 153.39 110.24 152.74 108.88"/></g></g><g><path fill="#fff" d="M431.51,96.64c0-1.93.37-3.75,1.1-5.45.73-1.7,1.73-3.18,3-4.45,1.26-1.26,2.75-2.26,4.45-3,1.7-.73,3.52-1.1,5.45-1.1s3.75.37,5.45,1.1c1.7.74,3.18,1.74,4.45,3,1.26,1.27,2.26,2.75,3,4.45.74,1.7,1.1,3.52,1.1,5.45s-.37,3.73-1.1,5.41c-.74,1.68-1.74,3.14-3,4.38-1.26,1.24-2.75,2.23-4.45,2.97-1.7.73-3.54,1.1-5.52,1.1s-3.75-.36-5.45-1.07c-1.7-.71-3.17-1.69-4.41-2.93-1.24-1.24-2.23-2.7-2.96-4.38-.74-1.68-1.1-3.51-1.1-5.48M433.92,96.64c0,1.61.3,3.11.9,4.52.6,1.4,1.41,2.62,2.45,3.65,1.04,1.03,2.25,1.85,3.66,2.45,1.4.6,2.91.9,4.52.9s3.11-.3,4.52-.9c1.4-.6,2.63-1.41,3.69-2.45,1.06-1.04,1.88-2.25,2.48-3.65.6-1.4.9-2.91.9-4.52s-.3-3.11-.9-4.52c-.6-1.4-1.42-2.63-2.48-3.69-1.06-1.06-2.29-1.88-3.69-2.48-1.4-.6-2.91-.9-4.52-.9s-3.11.3-4.52.9c-1.4.6-2.62,1.43-3.66,2.48-1.03,1.06-1.85,2.29-2.45,3.69-.6,1.4-.9,2.91-.9,4.52"/><path fill="#fff" d="M484.61,105.67c.28.28.54.56.79.86.25.3.49.61.72.93-1.2.92-2.53,1.65-4,2.21-1.47.55-3.06.83-4.76.83-1.93,0-3.75-.37-5.45-1.1-1.7-.74-3.19-1.72-4.45-2.97-1.27-1.24-2.25-2.7-2.97-4.38-.71-1.68-1.07-3.48-1.07-5.41s.35-3.75,1.07-5.45c.71-1.7,1.7-3.17,2.97-4.41,1.26-1.24,2.75-2.23,4.45-2.96,1.7-.74,3.51-1.1,5.45-1.1,1.7,0,3.3.28,4.79.83,1.49.55,2.84,1.29,4.03,2.21-.23.32-.48.62-.76.9-.28.28-.55.6-.83.97-.97-.78-2.07-1.4-3.31-1.86-1.24-.46-2.55-.69-3.93-.69-1.65,0-3.18.3-4.58.9-1.4.6-2.62,1.41-3.66,2.45-1.03,1.03-1.85,2.27-2.45,3.69-.6,1.42-.9,2.94-.9,4.55s.3,3.11.9,4.52c.6,1.4,1.41,2.62,2.45,3.65,1.03,1.04,2.25,1.85,3.66,2.45,1.4.6,2.93.9,4.58.9,1.38,0,2.69-.22,3.93-.65,1.24-.44,2.34-1.05,3.31-1.83"/><polygon fill="#fff" points="501.25 75.6 503.67 75.6 503.67 86.05 513.23 86.05 513.23 88.19 503.67 88.19 503.67 103.84 501.25 103.84 501.25 88.19 491.94 88.19 491.94 86.05 501.25 86.05 501.25 75.6"/><path fill="#fff" d="M518.1,96.71c0-1.93.37-3.75,1.1-5.45.73-1.7,1.72-3.18,2.96-4.45,1.24-1.26,2.28-2.26,3.95-3,1.68-.73,3.48-1.1,5.41-1.1,1.38,0,2.69.2,3.93.59,1.24.39,2.37.93,3.38,1.62,1.01.69,1.9,1.48,2.66,2.38.76.9,1.34,1.85,1.76,2.86,0-1.15.02-2.3.07-3.45.04-1.15.11-2.28.21-3.38h2.07v26.69h-2.34v-6.83c-.78,2.02-2.21,3.75-4.27,5.17-2.07,1.42-4.55,2.14-7.45,2.14-1.98,0-3.8-.37-5.48-1.1-1.68-.73-2.71-1.72-3.95-2.97-1.24-1.24-2.22-2.7-2.93-4.38-.71-1.68-1.07-3.46-1.07-5.34M520.44,96.64c0,1.61.3,3.11.9,4.52.6,1.4,1.41,2.62,2.45,3.65,1.03,1.03,1.84,1.85,3.26,2.45,1.42.6,2.94.9,4.55.9s3.13-.3,4.55-.9c1.42-.6,2.67-1.41,3.72-2.45,1.06-1.04,1.88-2.25,2.48-3.65.6-1.4.9-2.91.9-4.52s-.3-3.13-.9-4.55c-.6-1.42-1.43-2.66-2.48-3.69-1.06-1.03-2.3-1.85-3.72-2.45-1.42-.6-2.94-.9-4.55-.9s-3.13.3-4.55.9c-1.42.6-2.23,1.41-3.26,2.45-1.04,1.03-1.85,2.27-2.45,3.69-.6,1.42-.9,2.94-.9,4.55"/></g></g></g></svg>
);

// 使用目的の定義 (製品画像の情報に基づいて更新)
const purposes = [
  { id: 'norovirus_disposal', name: 'ノロウイルス感染時の除菌支援', icon: <ShieldAlert size={24} className="text-red-600" />, recommendedPPM: 400, description: '吐瀉物や排泄物の処理時 (400ppm以上)' },
  { id: 'bathroom_mold_strong', name: '風呂場のカビ取り (強力)', icon: <Bath size={24} className="text-red-500" />, recommendedPPM: 400, description: 'トイレ便器内清掃にも (400ppm以上)' },
  { id: 'kitchen_tools', name: 'キッチン用品の除菌支援', icon: <Utensils size={24} className="text-green-500" />, recommendedPPM: 200, description: '包丁、まな板、ふきん、シンク、三角コーナー' },
  { id: 'trashcan_ac_disinfection', name: 'ゴミ箱・エアコンの除菌消臭', icon: <SprayCan size={24} className="text-green-600" />, recommendedPPM: 200, description: 'ゴミ箱の除菌、エアコンの除菌・消臭に' },
  { id: 'car_deodorize_general', name: '車内の消臭 (通常)', icon: <Car size={24} className="text-indigo-500" />, recommendedPPM: 100, description: 'タバコ臭、一般的な車内臭に' },
  { id: 'fabric_deodorize', name: '布製品の消臭', icon: <Shirt size={24} className="text-pink-500" />, recommendedPPM: 100, description: 'カーテン(焼肉後)、寝具、下駄箱、靴など' },
  { id: 'pet_area_deodorize', name: 'ペット周りの消臭', icon: <PawPrint size={24} className="text-orange-500" />, recommendedPPM: 100, description: 'ペットのトイレや寝床の消臭に' },
  { id: 'kids_baby_items', name: 'キッズ・ベビー用品の除菌支援', icon: <Baby size={24} className="text-blue-400" />, recommendedPPM: 30, description: 'おもちゃ、哺乳瓶など (使用後すすぎ推奨)' },
  { id: 'pet_feeder_disinfection', name: 'ペットの餌容器の除菌支援', icon: <PawPrint size={24} className="text-orange-400" />, recommendedPPM: 30, description: '使用後すすぎ推奨'},
  { id: 'space_spray_deodorize', name: '空間噴霧による消臭 (低濃度)', icon: <CloudFog size={24} className="text-teal-500" />, recommendedPPM: 30, description: '専用噴霧器（加湿器タイプ）使用' },
  { id: 'custom', name: 'カスタム設定', icon: <Edit3 size={24} className="text-gray-500" />, recommendedPPM: 100, description: '濃度と水量を自由に設定' },
];


// ヘルパー関数：薬量計算
const calculateChemicalAmount = (ppm, waterLiters) => {
  if (waterLiters <= 0 || ppm <= 0) return 0;
  return (ppm * waterLiters * 0.001) / NIO1SE_FACTOR;
};

// ヘルパー関数：濃度計算
const calculatePPM = (chemicalGrams, waterLiters) => {
  if (waterLiters <= 0 || chemicalGrams <= 0) return 0;
  return (NIO1SE_FACTOR * chemicalGrams * 1000) / waterLiters;
};

// Markdown文字列を基本的なHTMLに変換する関数
const simpleMarkdownToHtml = (markdownText) => {
  if (!markdownText) return "";
  let htmlText = String(markdownText);

  // 見出し (## text, # text)
  htmlText = htmlText.replace(/^## (.*$)/gim, '<h2 class="text-xl font-semibold my-2">$1</h2>');
  htmlText = htmlText.replace(/^# (.*$)/gim, '<h1 class="text-2xl font-bold my-3">$1</h1>');
  
  // リスト (* item, - item)
  htmlText = htmlText.replace(/^\* (.*$)/gim, '<li class="ml-5 list-disc">$1</li>');
  htmlText = htmlText.replace(/^- (.*$)/gim, '<li class="ml-5 list-disc">$1</li>'); // ドットを追加
  
  // 簡易的なリストの開始と終了を検出して<ul>タグで囲む (不完全な場合あり)
  // この部分は複雑で、単純な置換では正確な<ul>の囲みが難しいため、
  // AIに各リスト項目を<li>で出力させ、CSSでリスト風に見せるか、
  // より高度なパーサーを検討する必要があります。
  // 今回は、個別の<li>として出力し、CSSでインデントとマーカーを適用する形とします。
  // 連続する<li>を<ul>で囲む処理は一旦コメントアウトします。
  // if (htmlText.includes('<li')) {
  //     htmlText = htmlText.replace(/(<li.*<\/li>\s*)+/g, (match) => `<ul class="my-2">${match}</ul>`);
  // }

  // 太字 (**text**)
  htmlText = htmlText.replace(/\*\*(.*?)\*\*/g, '<strong class="font-semibold">$1</strong>');
  
  // 改行
  htmlText = htmlText.replace(/\n/g, '<br />');

  return htmlText;
};


const App = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedPurpose, setSelectedPurpose] = useState(null);
  const [waterAmountLiters, setWaterAmountLiters] = useState(1.0);
  const [targetPPM, setTargetPPM] = useState(100); // デフォルト値を100PPMに変更
  const [chemicalAmountGrams, setChemicalAmountGrams] = useState(0);
  const [isEditingPPM, setIsEditingPPM] = useState(false);

  // Gemini API関連のstate
  const [llmAdvice, setLlmAdvice] = useState("");
  const [isLoadingLLM, setIsLoadingLLM] = useState(false);
  const [llmError, setLlmError] = useState("");

  const totalSteps = 4;

  const handlePurposeSelect = (purpose) => {
    setSelectedPurpose(purpose);
    setTargetPPM(purpose.recommendedPPM);
    setIsEditingPPM(false);
    setLlmAdvice("");
    setLlmError("");
    if (purpose.id === 'custom') {
      setIsEditingPPM(true);
    }
    setCurrentStep(2);
  };

  const handleWaterAmountChange = (value) => {
    const newWaterAmount = Math.max(0.1, Math.min(200, parseFloat(value)));
    setWaterAmountLiters(newWaterAmount);
    setLlmAdvice(""); 
    setLlmError("");
  };

  const handleTargetPPMChange = (value) => {
    const newPPM = Math.max(1, Math.min(5000, parseInt(value, 10))); // 製品特性上、上限を設けることも検討
    setTargetPPM(newPPM);
    setLlmAdvice("");
    setLlmError("");
  };

  const updateCalculations = useCallback(() => {
    const calculatedGrams = calculateChemicalAmount(targetPPM, waterAmountLiters);
    setChemicalAmountGrams(calculatedGrams);
  }, [targetPPM, waterAmountLiters]);

  useEffect(() => {
    updateCalculations();
  }, [updateCalculations]);

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setLlmAdvice(""); 
      setLlmError("");
    }
  };

  const resetAll = () => {
    setCurrentStep(1);
    setSelectedPurpose(null);
    setWaterAmountLiters(1.0);
    setTargetPPM(100);
    setChemicalAmountGrams(0);
    setIsEditingPPM(false);
    setLlmAdvice("");
    setLlmError("");
  };

  // Gemini API呼び出し関数（Cloudflare Pages Functions経由）
  const fetchLLMAdvice = async () => {
    if (!selectedPurpose) return;

    setIsLoadingLLM(true);
    setLlmAdvice("");
    setLlmError("");

    const actualPPM = calculatePPM(chemicalAmountGrams, waterAmountLiters);
    const prompt = `
あなたは「Nio1SE」という製品の専門アドバイザーです。
Nio1SEは、主成分が「ジクロロイソシアヌル酸ナトリウム 二水和物」で、60g入りの顆粒タイプの消臭・除菌支援剤です。水で希釈して使用します。
この製品は、使用する分だけをその都度作るのがポイントで、作り置きすると効果が低下します。
布製品に使用する場合、特に濃色やデリケートな素材は色落ちや変質の可能性があるため、目立たない場所で試してから使用することが推奨されます。また、布製品の臭いの元は繊維の奥にあるため、しっかり浸透するように噴霧することが効果的ですが、500ppm以上の濃度は避けるべきです。

ユーザーは以下の条件でNio1SE水溶液を調製しようとしています。

【ユーザーの設定情報】
- 使用目的: ${selectedPurpose.name} (${selectedPurpose.description})
- 調製する水溶液の目標濃度: ${targetPPM} PPM
- 調製する水量: ${waterAmountLiters.toFixed(1)} L (${waterAmountLiters * 1000} ml)
- 必要なNio1SE（顆粒）の量: ${chemicalAmountGrams.toFixed(2)} g
- 予測される実際の塩素濃度: 約 ${actualPPM.toFixed(0)} PPM

【アドバイスの構成】
上記ユーザーの設定情報と製品情報に基づき、以下の点を盛り込んだ具体的なアドバイスをMarkdown形式（見出しは##、リストは行頭にハイフンとスペース(- )、太字は**text**）で生成してください。

1.  **目的 (${selectedPurpose.name}) に対する ${actualPPM.toFixed(0)} PPM濃度のNio1SE溶液の具体的な使用手順:**
    * 希釈液の準備から、対象物への適用方法、必要な放置時間、後処理（拭き取り、すすぎ等）までをステップごとに説明してください。
    * 特に、${waterAmountLiters.toFixed(1)}L の水量に対して ${chemicalAmountGrams.toFixed(2)}g を使用する点を意識してください。
2.  **期待できる効果:**
    * この濃度と使用方法で、どのような効果（消臭、除菌など）が期待できるか具体的に述べてください。
3.  **特に注意すべき点（ユーザー設定に応じて強調点を変える）:**
    * 対象物の材質による影響（変色、腐食など）。特に「${selectedPurpose.name}」の目的でこの濃度の溶液を使用する場合、どのような材質に注意が必要か。
    * 換気の重要性（特に車内や狭い空間での使用時）。
    * 適切な保護具（マスク、手袋、保護眼鏡）の着用。
    * 他の薬剤との混合禁止（塩素系薬剤、酸、アルカリなどとの混合による有毒ガス発生や爆発の危険性）。
    * 使用後の適切な処理（おもちゃや食器の場合は十分なすすぎ等）。
4.  **関連情報とヒント:**
    * ユーザーの設定（目的、濃度、水量）に関連する追加のヒントや豆知識があれば提供してください。

【Nio1SE 一般的な使用上の注意（必ず含めること）】
- 用途以外に使用しない。
- 作業時は必ず適切な保護具を着用する。
- 【警告】他の薬剤と絶対に混合しない。
- 作業中は十分換気する。
- 衣服や金属への影響に注意する。
- 子供やペットの手の届かない場所に保管する。
- 目や皮膚への付着、誤飲時の応急処置と医師の診察。

【Nio1SE 一般的な保管上の注意（必ず含めること）】
- 密栓し、冷暗所に保管する。
- 高温多湿、凍結、直射日光を避ける。

安全に関する情報は特に強調し、ユーザーが安全かつ効果的に作業できるよう、具体的で実践的な内容にしてください。
`;

    try {
      const chatHistory = [{ role: "user", parts: [{ text: prompt }] }];
      const payload = { contents: chatHistory };
      
      // Cloudflare Pages Functionのエンドポイントを使用
      // 開発環境では相対パスを使用し、本番環境では自動的に正しいURLになります
      const functionUrl = "/api/ask-gemini";
      
      const response = await fetch(functionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("API Error:", errorData);
        throw new Error(`APIからの応答エラー: ${response.status} ${response.statusText}. ${errorData?.error?.message || ''}`);
      }

      const result = await response.json();

      if (result.candidates && result.candidates.length > 0 &&
          result.candidates[0].content && result.candidates[0].content.parts &&
          result.candidates[0].content.parts.length > 0) {
        const text = result.candidates[0].content.parts[0].text;
        setLlmAdvice(text);
      } else {
        console.error("API Error: Unexpected response structure", result);
        throw new Error("AIからの有効なアドバイスを取得できませんでした。応答の形式が正しくありません。");
      }
    } catch (error) {
      console.error("LLMアドバイスの取得に失敗しました:", error);
      setLlmError(`AIアドバイスの取得中にエラーが発生しました：${error.message} しばらくしてから再試行してください。`);
    } finally {
      setIsLoadingLLM(false);
    }
  };


  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
            {purposes.map((purpose) => (
              <button
                key={purpose.id}
                onClick={() => handlePurposeSelect(purpose)}
                className="p-3 sm:p-5 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 text-left flex flex-col items-center justify-start min-h-[160px] sm:min-h-[200px]"
              >
                <div className="mb-2 sm:mb-3 transform scale-125 sm:scale-150">
                  {React.cloneElement(purpose.icon, { size: 32 })}
                </div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-1 text-center">{purpose.name}</h3>
                <p className="text-sm text-gray-600 mb-1 text-center flex-grow">{purpose.description}</p>
                <p className="text-sm text-indigo-600 font-medium text-center mt-auto">推奨: {purpose.recommendedPPM} PPM</p>
              </button>
            ))}
          </div>
        );
      case 2: 
        return (
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">ステップ2: 水量を入力してください</h2>
            {selectedPurpose && (
              <div className="mb-4 p-3 bg-indigo-50 rounded-lg border border-indigo-200">
                <p className="text-sm text-indigo-700">
                  <Info size={16} className="inline mr-2" />
                  選択中の目的: <span className="font-semibold">{selectedPurpose.name}</span> (推奨濃度: {selectedPurpose.recommendedPPM} PPM)
                </p>
              </div>
            )}
            <div className="mb-6">
              <label htmlFor="waterAmount" className="block text-sm font-medium text-gray-700 mb-1">
                水量 (リットル)
              </label>
              <div className="flex items-center space-x-2">
                <input
                  type="range"
                  id="waterAmountSlider"
                  min="0.1"
                  max="20"
                  step="0.1"
                  value={waterAmountLiters}
                  onChange={(e) => handleWaterAmountChange(e.target.value)}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                />
                <input
                  type="number"
                  id="waterAmount"
                  value={waterAmountLiters}
                  onChange={(e) => handleWaterAmountChange(e.target.value)}
                  min="0.1"
                  max="200"
                  step="0.1"
                  className="w-24 p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                />
                <span className="text-sm text-gray-600">L</span>
              </div>
              <p className="text-xs text-gray-500 mt-1">0.1L (100ml) から 200L まで入力可能です。</p>
            </div>
            <div className="flex flex-wrap gap-2 mb-4">
              {[0.5, 1, 1.5, 2, 5, 10, 18].map(amount => (
                <button
                  key={amount}
                  onClick={() => handleWaterAmountChange(amount)}
                  className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors duration-150
                    ${waterAmountLiters === amount ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  {amount}L {amount === 0.5 ? '(500ml)' : amount === 1.5 ? '(1500ml)' : ''}
                </button>
              ))}
            </div>
            <p className="text-sm text-gray-600">
              現在設定されている水量: <span className="font-semibold">{waterAmountLiters} L</span> ({waterAmountLiters * 1000} ml)
            </p>
          </div>
        );
      case 3: 
        return (
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">ステップ3: 濃度を調整 (任意)</h2>
            {selectedPurpose && (
              <div className="mb-4 p-3 bg-indigo-50 rounded-lg border border-indigo-200">
                <p className="text-sm text-indigo-700">
                  <Info size={16} className="inline mr-2" />
                  選択中の目的: <span className="font-semibold">{selectedPurpose.name}</span>
                </p>
                <p className="text-sm text-indigo-700">
                  推奨濃度: <span className="font-semibold">{selectedPurpose.recommendedPPM} PPM</span>
                </p>
              </div>
            )}
            <div className="mb-6">
              <label htmlFor="targetPPM" className="block text-sm font-medium text-gray-700 mb-1">
                目標濃度 (PPM)
              </label>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handleTargetPPMChange(targetPPM - (targetPPM > 100 ? 50 : 10))}
                  disabled={!isEditingPPM && selectedPurpose?.id !== 'custom'}
                  className="px-3 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  -
                </button>
                <input
                  type="number"
                  id="targetPPM"
                  value={targetPPM}
                  onChange={(e) => handleTargetPPMChange(e.target.value)}
                  min="1"
                  max="5000"
                  step="10"
                  disabled={!isEditingPPM && selectedPurpose?.id !== 'custom'}
                  className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-sm disabled:bg-gray-50"
                />
                <button
                  onClick={() => handleTargetPPMChange(targetPPM + (targetPPM >= 100 ? 50 : 10))}
                  disabled={!isEditingPPM && selectedPurpose?.id !== 'custom'}
                  className="px-3 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  +
                </button>
              </div>
              {selectedPurpose?.id !== 'custom' && (
                <button
                  onClick={() => setIsEditingPPM(!isEditingPPM)}
                  className="mt-2 text-sm text-indigo-600 hover:text-indigo-800 flex items-center"
                >
                  {isEditingPPM ? <XCircle size={16} className="mr-1" /> : <Edit3 size={16} className="mr-1" />}
                  {isEditingPPM ? '推奨濃度に戻す' : '手動で濃度を編集する'}
                </button>
              )}
               {isEditingPPM && selectedPurpose?.id !== 'custom' && (
                 <button
                    onClick={() => { setTargetPPM(selectedPurpose.recommendedPPM); setIsEditingPPM(false); }}
                    className="mt-2 ml-2 text-sm text-gray-600 hover:text-gray-800 flex items-center"
                  >
                    <RefreshCw size={16} className="mr-1" />
                    推奨濃度 ({selectedPurpose.recommendedPPM} PPM) にリセット
                  </button>
               )}
            </div>
            <p className="text-sm text-gray-600">
              現在設定されている目標濃度: <span className="font-semibold">{targetPPM} PPM</span>
            </p>
          </div>
        );
      case 4:
        const actualPPM = calculatePPM(chemicalAmountGrams, waterAmountLiters);
        const adviceHtml = simpleMarkdownToHtml(llmAdvice); // MarkdownをHTMLに変換

        return (
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
              <CheckCircle size={24} className="mr-2 text-green-500" />
              ステップ4: 計算結果と調製ガイド
            </h2>
            
            <div className="space-y-3 mb-6">
              <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                <h3 className="text-md font-semibold text-green-800 mb-1">必要なNio1SEの量 (顆粒):</h3>
                <p className="text-2xl font-bold text-green-700">{chemicalAmountGrams.toFixed(2)} g</p>
              </div>
              <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                <h3 className="text-md font-semibold text-blue-800 mb-1">調製する水溶液の情報:</h3>
                <p className="text-sm text-blue-700">水量: {waterAmountLiters} L ({waterAmountLiters * 1000} ml)</p>
                <p className="text-sm text-blue-700">目標濃度: {targetPPM} PPM</p>
                <p className="text-sm text-blue-700">予測される実際の濃度: {actualPPM.toFixed(0)} PPM</p>
              </div>
            </div>

            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">調製方法</h3>
              <ol className="list-decimal list-inside space-y-1 text-sm text-gray-600">
                <li>清潔な容器を用意します。</li>
                <li>指定量の水 ({waterAmountLiters} L) を容器に入れます。</li>
                <li>計算された量のNio1SE ({chemicalAmountGrams.toFixed(2)} g の顆粒) を加え、静かに溶けるまでよくかき混ぜます。</li>
                <li>調製した溶液は、効果が低下するため、**使う分だけその都度作り、早めに使い切ってください。**</li>
              </ol>
            </div>

            {/* Gemini API アドバイスセクション */}
            <div className="my-6">
              <button
                onClick={fetchLLMAdvice}
                disabled={isLoadingLLM}
                className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-4 rounded-lg shadow-md transition-colors duration-150 flex items-center justify-center disabled:opacity-70 disabled:cursor-wait"
              >
                {isLoadingLLM ? (
                  <Loader2 size={20} className="animate-spin mr-2" />
                ) : (
                  <Sparkles size={20} className="mr-2" />
                )}
                {isLoadingLLM ? 'AIがアドバイスを生成中...' : '✨ AIによる詳細情報と追加アドバイス'}
              </button>
              {llmError && (
                <div className="mt-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded-md text-sm">
                  <AlertTriangle size={16} className="inline mr-1" /> {llmError}
                </div>
              )}
              {llmAdvice && !isLoadingLLM && (
                <div className="mt-4 p-4 bg-purple-50 border border-purple-200 rounded-lg">
                  <h4 className="text-lg font-semibold text-purple-800 mb-2">AIからのアドバイス (Nio1SE):</h4>
                  <div className="text-sm text-gray-700 space-y-2" dangerouslySetInnerHTML={{ __html: adviceHtml }} />
                </div> 
              )}
            </div>
            
            <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-300">
              <h3 className="text-lg font-semibold text-yellow-800 mb-2 flex items-center">
                <AlertTriangle size={20} className="mr-2 text-yellow-600" />
                重要: Nio1SE 使用上・保管上の注意
              </h3>
              <p className="text-sm font-medium text-yellow-700 mb-1">【使用上の注意】</p>
              <ul className="list-disc list-inside space-y-1 text-sm text-yellow-700 mb-3">
                <li>用途以外に使用しないでください。</li>
                <li>作業時は必ず適切な保護具（**保護メガネ、保護手袋、保護マスク**）を着用してください。眼、皮膚、呼吸器を腐食する危険があります。</li>
                <li>**【警告】他の塩素系薬剤（次亜塩素酸ソーダ、次亜塩素酸カルシウム、二酸化塩素など）、酸、アルカリ、脱塩素剤（チオ硫酸ソーダ、亜硫酸ソーダ）、油脂類、その他可燃物と絶対に直接混合したり、接触させたりしないでください。急激な塩素ガス（有毒）の発生や爆発の危険があります。**</li>
                <li>作業中は十分な換気を行ってください（特に車内などの密閉空間）。</li>
                <li>衣服や色の濃い布製品、皮革製品に付着すると変色・脱色する恐れがあります。目立たない場所で試してから使用し、付着した場合は速やかに水で洗い流すか洗濯してください。**布類への使用は500ppm以下の濃度を推奨します。**</li>
                <li>金属製品（特にアルミニウム、銅、真鍮など）に長期間接触させると腐食する可能性があります。使用後は水で十分に洗い流すか拭き取ってください。</li>
                <li>目や皮膚に付着した場合：直ちに大量の水で15分以上洗い流し、異常があれば速やかに医師の診察を受けてください。</li>
                <li>誤って飲み込んだ場合：無理に吐かせず、直ちにコップ1～2杯の水または牛乳を飲ませ、医師の診察を受けてください。気分が悪いときも医師に連絡してください。</li>
                <li>吸い込まないように注意してください。</li>
              </ul>
              <p className="text-sm font-medium text-yellow-700 mb-1">【保管上の注意】</p>
              <ul className="list-disc list-inside space-y-1 text-sm text-yellow-700">
                <li>誤使用・誤飲やその他の事故を防ぐため、保管場所に注意してください。</li>
                <li>**密栓保管**し、子供や認知症の方、ペットの手の届かない所に置き、転倒、落下、破損、漏洩のないように注意してください。</li>
                <li>凍結の恐れのある所や直射日光の当たる所、温度が40℃以上になる所、水や湿気の多い所は避けて保管してください。</li>
              </ul>
            </div>
          </div>
        );
      default:
        return <div>不明なステップです。</div>;
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 font-sans">
      <header className="text-white shadow-md" style={{ backgroundColor: '#BDDFD8', backgroundImage: 'url(/bg.jpg)' }}>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 flex flex-col sm:flex-row justify-between items-center">
          <div className="flex flex-col sm:flex-row items-center mb-2 sm:mb-0">
            <ProductLogo className="h-14 sm:h-16 w-auto mb-2 sm:mb-0 sm:mr-3" />
            <div>
              <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-center sm:text-left">Nio1SE スマート濃度アシスト</h1>
            </div>
          </div>
          <button
            onClick={resetAll}
            className="bg-white text-indigo-600 px-4 py-2 rounded-md shadow hover:bg-indigo-50 transition-colors duration-150 text-sm font-medium flex items-center"
          >
            <RefreshCw size={16} className="mr-2" />
            最初からやり直す
          </button>
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-indigo-600">ステップ {currentStep} / {totalSteps}</span>
            {currentStep > 1 && selectedPurpose && (
              <span className="text-xs text-gray-500">選択中の目的: {selectedPurpose.name}</span>
            )}
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-indigo-500 h-2.5 rounded-full transition-all duration-500 ease-out"
              style={{ width: `${(currentStep / totalSteps) * 100}%` }}
            ></div>
          </div>
        </div>

        <div className="mb-8">
          {renderStepContent()}
        </div>

        <div className="flex justify-between items-center">
          <button
            onClick={prevStep}
            disabled={currentStep === 1}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-lg shadow transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          >
            <ChevronLeft size={20} className="mr-1" />
            戻る
          </button>
          {currentStep < totalSteps ? (
            <button
              onClick={nextStep}
              disabled={(currentStep === 1 && !selectedPurpose) || (currentStep === 2 && waterAmountLiters <= 0)}
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg shadow transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
            >
              次へ
              <ChevronRight size={20} className="ml-1" />
            </button>
          ) : (
            <button
              onClick={resetAll}
              className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg shadow transition-colors duration-150 flex items-center"
            >
              <RefreshCw size={16} className="mr-2" />
              新しく計算する
            </button>
          )}
        </div>
      </main>

      <footer className="bg-gray-800 text-gray-300 text-center py-6 mt-12">
        <div className="mb-3">
          <MakerLogo className="h-8 w-auto mx-auto opacity-80" />
        </div>
        <p className="text-sm">&copy; {new Date().getFullYear()} Adamas octa / Nio1SE スマート濃度アシスト</p>
        <p className="text-xs mt-1">提供: 株式会社シイ・アイ・エス (ブランド名: Adamas Octa)</p>
        <p className="text-xs mt-1">このツールは計算補助を目的としており、AIによるアドバイスは参考情報です。実際の調製・使用は製品の指示に従い、自己責任で行ってください。</p>
      </footer>
    </div>
  );
};

export default App;
